import Policy from './Policy'

// Backend policies resolved in: backend/components/enps/app/presenters/enps/enps_form_presenter.rb
export type EnpsFormVerbTypes = 'editEnpsForm'

class EnpsFormPolicy extends Policy<EnpsFormVerbTypes> {
  checkVerb(verb: EnpsFormVerbTypes): boolean {
    switch (verb) {
      case 'editEnpsForm':
        return this.permissions.edit

      default:
        throw new Error(`Unknown verb ${verb} in policy`)
    }
  }
}

export default EnpsFormPolicy
